export default __webpack_public_path__ + "static/media/addon-banner.78ee9de8.png";